"use strict";

import React from "react";
import PropTypes from "prop-types";
import classnames from 'classnames';

const DocumentIcon = ({ text, disabled, onClick, ...rest }) => {
    const className = classnames('document-icon', rest.className, {
        'document-icon--disabled': !!disabled
    });

    return (
        <div {...rest} onClick={onClick} className={className}>
            <svg version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width="26px" height="30px" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <mask fill="white" id="clip1">
                        <path d="M 0 0  L 0 27  L 23 27  L 23 8  L 14.6363636363636 0  L 0 0  Z " fill-rule="evenodd" />
                    </mask>
                </defs>
                <g className="document-icon__content-area">
                    <g transform="matrix(1 0 0 1 -891 -272 )">
                        <path d="M 0 0  L 0 27  L 23 27  L 23 8  L 14.6363636363636 0  L 0 0  Z M 22 8  L 14.6363636363636 0.875  L 14.6363636363636 8  L 22 8  Z " fill-rule="nonzero" fill="#ffffff" fill-opacity="0" stroke="none" transform="matrix(1 0 0 1 892 273 )" />
                        <path className="document-icon__border" d="M 0 0  L 0 27  L 23 27  L 23 8  L 14.6363636363636 0  L 0 0  Z " stroke-width="4" fill="none" transform="matrix(1 0 0 1 892 273 )" mask="url(#clip1)" />
                        <path className="document-icon__border" d="M 14.6363636363636 0.875  L 14.6363636363636 8  L 22 8  " stroke-width="2" fill="none" transform="matrix(1 0 0 1 892 273 )" mask="url(#clip1)" />
                    </g>
                    <text className="document-icon__text" x="5px" y="23px" font-size="9px" stroke="none">{text}</text>
                </g>
            </svg>
        </div>
    );
};

DocumentIcon.propTypes = {
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

module.exports = DocumentIcon;